module.exports = __webpack_public_path__ + "img/Dantam Hair 57.aedaba93.jpg";